import React from "react";
import { CtaWrapper } from "./LoginRegisterButtons.styles";
import { Button } from "..";
import { loginRedirect, registerRedirect } from "../../utils/auth";
import { useRouter } from "next/router";

export interface CustomVariantLoginRegisterButtonsProps {
    showLoginButton?: boolean;
    showRegisterButton?: boolean;
}

export const LoginRegisterButtons = ({
    showLoginButton,
    showRegisterButton,
}: CustomVariantLoginRegisterButtonsProps) => {
    const router = useRouter();

    return (
        <CtaWrapper>
            {showLoginButton && (
            <Button
                data-cy="login-status-no-user"
                onClick={() => loginRedirect(router, window.location.href)}
                size="md"
                variant="tertiary"
            >
                Login
            </Button>
            )}
            {showRegisterButton && (
            <Button
                data-cy="register-status-no-user"
                onClick={() => registerRedirect(router)}
                variant="secondary"
                size="md"
            >
                Become a Member
            </Button>
            )}
      </CtaWrapper>
    );
};

export interface LoginRegisterButtonsProps extends React.ComponentProps<typeof LoginRegisterButtons> {
    as?: React.ElementType;
}

LoginRegisterButtons.displayName = "LoginRegisterButtons";
